import { render, staticRenderFns } from "./dAlertWarning.vue?vue&type=template&id=50b32d05&scoped=true&"
import script from "./dAlertWarning.vue?vue&type=script&lang=js&"
export * from "./dAlertWarning.vue?vue&type=script&lang=js&"
import style0 from "./dAlertWarning.vue?vue&type=style&index=0&id=50b32d05&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b32d05",
  null
  
)

export default component.exports